import router from 'router';

export const getOverviewPathFromType = ({
    type,
    id,
    redirectQuery = '',
    redirectTab = '',
    redirectTabPurchase = '',
    subType,
}) => {
    switch (type) {
        case 'client':
            return router.resolve({
                name: 'third.overview',
                params: { id: id, type: subType ?? 'client' },
            }).href;
        case 'estimate':
            return '/?_f=estimateOverview&id=' + id + redirectTab;
        case 'invoice':
            return '/?_f=invoiceOverview&id=' + id + redirectTab;
        case 'item':
            return '/?_f=catalogueitem&id=' + id;
        case 'model':
            return '/?_f=modelOverview&id=' + id + redirectTab;
        case 'creditnote':
            return '/?_f=creditnoteOverview&id=' + id + redirectTab;
        case 'order':
            return '/?_f=orderOverview&id=' + id + redirectTab;
        case 'delivery':
            return '/?_f=deliveryOverview&id=' + id + redirectTab;
        case 'opportunity':
            return router.resolve({
                name: 'opportunity.overview.activity',
                params: { id },
                query: redirectQuery,
            }).href;
        case 'contact':
        case 'people':
            return router.resolve({
                name: 'people.overview.activity',
                params: { id },
                query: redirectQuery,
            }).href;
        case 'proforma':
            return '/?_f=proformaOverview&id=' + id + redirectTab;
        case 'purCreditNote':
            return '/?_f=purchases_purCreditNoteOverview&id=' + id + redirectTabPurchase;
        case 'purOrder':
            return '/?_f=purchases_purOrderOverview&id=' + id + redirectTabPurchase;
        case 'purDelivery':
            return '/?_f=purchases_purDeliveryOverview&id=' + id + redirectTabPurchase;
        case 'purInvoice':
            return '/?_f=purchases_purInvoiceOverview&id=' + id + redirectTabPurchase;
        case 'proptemplate':
            return '/?_f=proposal_proposal&type=proptemplate&id=' + id + redirectTabPurchase;
        case 'propdocument':
            return '/?_f=proposal_proposal&type=propdocument&id=' + id + redirectTabPurchase;
        case 'task':
            return '/?_f=tasks&id=' + id + '&view=Y';
        case 'company':
        case 'third':
        case 'individual':
            return router.resolve({
                name: 'third.overview.activity',
                params: { id: id, type: subType ?? 'client' },
                query: redirectQuery,
            }).href;
        case 'ticket':
        case 'support':
            return '?_f=support_ticket&tid=' + id;
        case 'email':
            switch (subType) {
                case 'client':
                case 'company':
                    return router.resolve({
                        name: 'third.overview.activity',
                        params: { id: id, type: 'client' },
                        query: redirectQuery,
                    }).href;
                case 'contact':
                    return router.resolve({
                        name: 'people.overview.activity',
                        params: { id: id },
                        query: redirectQuery,
                    }).href;
                case 'invoice':
                    return (
                        '/?_f=invoiceOverview&id=' +
                        id +
                        redirectTabPurchase +
                        '&email=' +
                        redirectQuery.email +
                        '&redirectTab=' +
                        redirectQuery.redirectTab
                    );
                case 'estimate':
                    return (
                        '/?_f=estimateOverview&id=' +
                        id +
                        redirectTabPurchase +
                        '&email=' +
                        redirectQuery.email +
                        '&redirectTab=' +
                        redirectQuery.redirectTab
                    );
                case 'creditnote':
                    return (
                        '/?_f=creditnoteOverview&id=' +
                        id +
                        redirectTabPurchase +
                        '&email=' +
                        redirectQuery.email +
                        '&redirectTab=' +
                        redirectQuery.redirectTab
                    );
                case 'opportunity':
                    return router.resolve({
                        name: 'opportunity.overview.activity',
                        params: { id: id, type: 'opportunity' },
                        query: redirectQuery,
                    }).href;
                case 'individual':
                case 'prospect':
                case 'supplier':
                    return router.resolve({
                        name: 'third.overview',
                        params: { id: id, type: subType ?? 'client' },
                        query: redirectQuery,
                    }).href;
                default:
                    return '/';
            }
        default:
            return '/';
    }
};
